module.exports = __webpack_public_path__ + "img/xiangyou (2).7217dff7.png";